type Constructor<T = {}> = new (...args: any[]) => T;

export function Editable<TBase extends Constructor>(Base: TBase) {
  return class extends Base {
    editing: boolean = false;

    constructor(...args: any[]) {
      super(...args);
    }

    toggleEdit() {
      this.editing = !this.editing;
    }
  };
}
